import Stadium from '@ordernext/networking-stadium/stadium'
import PorticoRemote from '../../remote/porticoRemote'

/**
 * Custom hook for handling Portico login functionality
 *
 * @returns {Object} - login and updateTokens functions
 */
const useLogin = () => {
  /**
   * Update the access token and expiration time in localStorage
   *
   * @param {Object} data
   */
  const updateTokens = (data) => {
    const { accessToken, expiresAt } = data

    if (!accessToken) return

    // set updated tokens in localStorage
    localStorage.setItem('accessToken', accessToken)

    // set expiration time if provided
    if (expiresAt) {
      localStorage.setItem('expiresAt', expiresAt)
    }

    // set Stadium config
    Stadium.config = {
      ...Stadium.config,
      headers: {
        ...Stadium.config.headers,
        Authorization: `Bearer ${accessToken}`,
        'Cache-Control': 'no-cache, no-store',
        Pragma: 'no-cache',
        Expires: 0,
      },
    }
  }

  /**
   * Perform a device login against Portico
   *
   * @param {Function} onSuccess
   * @param {Function} onFailure
   */
  const login = (onSuccess, onFailure) => {
    try {
      PorticoRemote.postLogin()
        .then((data) => onSuccess(data?.data))
        .catch((err) => onFailure(err))
    } catch (error) {
      onFailure(error)
    }
  }

  return { login, updateTokens }
}

export default useLogin
